import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";

// Clickable column header that cycles asc -> desc. Pass the `column` object
// TanStack hands the header renderer.
export function SortableHeader({
  column,
  children,
}: {
  column: { toggleSorting: (desc?: boolean) => void; getIsSorted: () => false | "asc" | "desc" };
  children: React.ReactNode;
}) {
  const sorted = column.getIsSorted();
  return (
    <Button
      variant="ghost"
      size="sm"
      className="-ml-3 h-8 text-xs font-medium uppercase tracking-wide text-muted-foreground hover:text-foreground"
      onClick={() => column.toggleSorting(sorted === "asc")}
    >
      {children}
      {sorted === "asc" ? (
        <ArrowUp className="ml-1.5 h-3 w-3" />
      ) : sorted === "desc" ? (
        <ArrowDown className="ml-1.5 h-3 w-3" />
      ) : (
        <ChevronsUpDown className="ml-1.5 h-3 w-3 opacity-50" />
      )}
    </Button>
  );
}
